import React, { Component } from 'react'
import SettingsMenu from './SettingsMenu'
import SettingBooking from './SettingBooking'
import NotificationsMenu from './NotificationsMenu'
import { checkTranslation, conditionalWidth, imageAddress } from '../../utils/useful'
import ShoppingCartMenu from '../../windows/Applets/ShoppingCartMenu'
import SettingsCommerceUserMenu from './SettingsCommerceUserMenu'
import MainSettingsMenu from './MainSettingsMenu'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import DirectoryPathIndicator from '../../windows/Drive/DirectoryPathIndicator'
import { getBoundingClientRect } from '../../utils/functions'

class HeaderInformation extends Component {

    state = {
        itemsWidth: 0,
        profileImageWidth: 0,
        profileTextWidth: 0
    }

    componentDidMount() {
        if (this.items) {
            let items = this.items
            items.style.width = 'auto';
            items.style.width = (items.clientWidth) + "px";
            let width = getBoundingClientRect(items).width
            this.setState({ itemsWidth: width })
        }
        if (this.profileImage) {
            let profileImage = this.profileImage
            profileImage.style.width = 'initial';
            profileImage.style.width = (profileImage.clientWidth) + "px";
            let width = getBoundingClientRect(profileImage).width
            console.log('sadcesfcdfcrd', width)
            this.setState({ profileImageWidth: width })
        }
        if (this.profileText) {
            let profileText = this.profileText
            profileText.style.width = 'auto';
            profileText.style.width = (profileText.clientWidth) + "px";
            let width = getBoundingClientRect(profileText).width
            this.setState({ profileTextWidth: width })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.config?.showSettings && (this.props.config?.showSettings != prevProps.config?.showSettings)) {
            if (this.items) {
                let items = this.items
                items.style.width = 'auto';
                items.style.width = (items.clientWidth) + "px";
                let width = getBoundingClientRect(items).width
                this.setState({ itemsWidth: width })
            }
        }
    }

    render() {

        let title = this.props.config?.title ?? this.props.page?.title
        let image = this.props.config?.image ?? this.props.applet?.hub?.image

        if (title == '') {
            title = null
        }

        let type = this.props.config?.type ?? this.props.applet?.type

        if (!type && Array.isArray(this.props.applet?.features)) {
            type = this.props.applet.features[0]
        }

        let colors = this.props.colors

        // console.log(this.props.user?.info)

        return (

            <div className={' w-100 p-2 ' + conditionalWidth(this.props.width, { xs: ' flexcc  ', sm: ' flexcc ' })}>

                <div className={" " + conditionalWidth(this.props.width, { xs: ' flexc w-100', sm: 'flexc w-100' })} style={{}}>
                    <div className='flexc' style={{ width: `calc(100% - ${this.state.itemsWidth}px)`, }}>
                        {this.props.config?.backAction && (
                            <button className='flexc' onClick={() => this.props.config?.backAction()}>
                                <img width={30} src="/assets/icons/back-white.svg" />
                            </button>
                        )}
                        {this.props.config?.headerIdentityComponent ? (
                            <div className='flexc w-100'>

                                <div className=' flexc' style={{ justifyContent: conditionalWidth(this.props.width, { xs: 'flex-end', sm: 'start' }) }}>
                                    {this.props.config?.headerIdentityComponent()}
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 flexc" style={{ position: 'sticky', top: 0 }}>
                                <div className='flexc' >

                                    {/* {this.props.config?.isPortal && (
                                            <div className='flexc'>
                                                <div className='mrd-4 flexc' style={{ position: 'relative' }} >
                                                    <img className="br-50" style={{ width: '40px', height: '40px', objectFit: 'cover', border: '2px solid #ffffff90' }} src={'/assets/icons/applets/' + type + ".png"} />
                                                </div>
                                            </div>
                                        )} */}

                                    {!this.props.config?.isPortal && (
                                        <div className={" flexcc " + conditionalWidth(this.props.width, { xs: '', sm: '' })}>
                                            <div className='mrd-4 flexcc' style={{ position: 'relative', }} >
                                                <img className="br-50" style={{ width: '40px', height: '40px', objectFit: 'cover', border: '2px solid #ffffff90' }} src={imageAddress(image, 'profile', 'thumb')} />
                                                {type &&
                                                    <div className='flexcc' style={{ position: 'absolute', bottom: -6, right: -6, backgroundColor: '#ffffffcc', borderRadius: 20, height: 24, width: 24 }}>
                                                        <img src={'/assets/icons/applets/' + String(type).toLowerCase() + ".png"} width="22px" style={{ height: 22, borderRadius: 100, objectFit: 'cover', border: '2px solid #ffffff90' }} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className='' ref={el => this.profileText = el}>
                                    {/* {(this.props.applet?.hub?.fullname || this.state.page?.title) && */}
                                    <div className='' >

                                        <div className=''>
                                            {(title) && (
                                                <div className='flexc'>
                                                    {this.props.config?.isPortal ?
                                                        <p className={' cursor-pointer mt-0 text-semibold ' + (this.props.config?.create ? 'text-normal' : 'font-size-22')} style={{ whiteSpace: "nowrap", color: colors?.textColor }} >{checkTranslation(title)}</p>
                                                        :
                                                        <p onClick={() => this.props.goToHub()} className=' cursor-pointer mt-0 text-normal  text-semibold' style={{ whiteSpace: "nowrap", color: colors?.textColor }} >{checkTranslation(title)}</p>
                                                    }
                                                    {/* {this.props.config?.subtitle && (
                                                    <div className='mld-2'>
                                                        <p className=' cursor-pointer mt-0 text-smaller  text-semibold' style={{ whiteSpace: "nowrap", color: colors?.textColor }} >[{checkTranslation(this.props.config?.subtitle)}]</p>
                                                    </div>
                                                )} */}
                                                </div>
                                            )}

                                            {this.props.applet && (
                                                <p className={"m-0  mb-0  flexc " + (title ? ('text-smaller opacity-7 ') : ('text-normal text-semibold'))} style={{ maxWidth: 450, whiteSpace: "nowrap", color: colors?.textColor }}>{checkTranslation(this.props.applet?.name)}{!title ? '' : ' / ' + this.props.applet?.hub?.fullname}</p>
                                            )}
                                            {this.props.username && (
                                                <p className={"m-0  mb-0  flexc " + (title ? ('text-smaller  ') : ('text-normal text-semibold'))} style={{ maxWidth: 450, whiteSpace: "nowrap", color: colors?.textColor, cursor: 'default' }}>@{(this.props?.username)}</p>
                                            )}

                                            {(!title) && (

                                                <p onClick={() => this.props.goToHub()} className=' cursor-pointer mt-0 text-smaller  opacity-7' style={{ whiteSpace: "nowrap", color: colors?.textColor }} >{this.props.applet?.hub?.fullname}</p>
                                            )}
                                        </div>
                                    </div>
                                    {/* } */}
                                </div>
                                {this.props.config?.navbarComponent && this.props.config?.paths && (
                                    <div className="flexcc" style={{ justifyContent: 'left', width: `calc(100% - ${this.state.profileImageWidth + this.state.profileTextWidth}px)` }}>
                                        {Array.isArray(this.props.config.paths) && this.props.config.paths.length > 0 &&
                                            // <DirectoryPathIndicator paths={this.props.config.pathNavbar} onChangeDirectory={this.props.config?.onChangeDirectory} language={this.props.language} changeNav={this.props.changeNav} />
                                            this.props.config.navbarComponent()
                                        }
                                    </div>
                                )}
                            </div>
                        )}
                    </div>



                    {!this.props.config?.topHeaderComponent && (
                        <div className=' flexc ' style={{ justifyContent: conditionalWidth(this.props.width, { xs: 'flex-end', sm: 'start' }) }}>
                            {this.props.showSearch && (
                                <button className={'px-1 flexc ' + (colors?.iconInvert ? 'invert' : '')} style={{ cursor: 'pointer' }} onClick={() => { this.ViewsIntractionActions?.filterFixedView?.filterEditor.open() }} >
                                    <img width={24} src='/assets/icons/applets/database/search-white.svg' alt=''/>
                                </button>
                            )}
                            <NotificationsMenu language={this.props.language} hub={this.props.hub} variables={this.props.variables} width={this.props.width} colors={this.props.colors} applet={this.props.applet} features={this.props.features} page={this.props.page} changeWindow={this.props.changeWindow} sections={this.props.sections} modules={this.props.modules} frames={this.props.frames} addNewWindow={this.props.addNewWindow} />
                            {this.props.config?.showSettings == 'bookingApplet' && (
                                <SettingBooking width={this.props.width} variables={this.props.variables} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                            )}
                            {(this.props.config?.showSettings == 'collectionBase' || this.props.config?.showSettings == true) && (
                                <SettingsMenu width={this.props.width} variables={this.props.variables} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                            )}
                            {this.props.config?.showSettings == 'SettingsApplet' && (
                                <MainSettingsMenu width={this.props.width} variables={this.props.variables} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                            )}
                            {this.props.config?.showCart && (
                                <ShoppingCartMenu addToCart={this.props.addToCart} cart={this.props.cart} config={this.props.config} width={this.props.width} variables={this.props.variables} language={this.props.language} functionsHandler={this.props.functionsHandler} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} changePage={this.props.changePage} />
                            )}
                            {this.props.config?.showSettings == 'commerceUser' && (
                                <SettingsCommerceUserMenu width={this.props.width} variables={this.props.variables} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                            )}


                        </div>
                    )}
                </div>



                {/* {!this.props.config?.topHeaderComponent && (
                    <div className=' flexc' ref={el => this.items = el} style={{ justifyContent: 'flex-end', }} >
                        {this.props.showSearch && (
                            <button className={'px-1 flexc ' + (colors?.iconInvert ? 'invert' : '')} style={{ cursor: 'pointer' }} onClick={() => { this.ViewsIntractionActions?.filterFixedView?.filterEditor.open() }} >
                                <img width={24} src='/assets/icons/applets/database/search-white.svg' />
                            </button>
                        )}
                        {!this.props.config?.doNotshowNotification &&
                            <NotificationsMenu language={this.props.language} width={this.props.width} colors={this.props.colors} applet={this.props.applet} features={this.props.features} />
                        }
                        {this.props.config?.showSettings == 'bookingApplet' && (
                            <SettingBooking width={this.props.width} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                        )}
                        {(this.props.config?.showSettings == 'collectionBase' || this.props.config?.showSettings == true) && (
                            <SettingsMenu width={this.props.width} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                        )}
                        {this.props.config?.showSettings == 'SettingsApplet' && (
                            <MainSettingsMenu width={this.props.width} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                        )}
                        {this.props.config?.showCart && (
                            <ShoppingCartMenu addToCart={this.props.addToCart} cart={this.props.cart} config={this.props.config} width={this.props.width} language={this.props.language} functionsHandler={this.props.functionsHandler} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                        )}
                        {this.props.config?.showSettings == 'commerceUser' && (
                            <SettingsCommerceUserMenu width={this.props.width} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                        )}
                    </div>
                )} */}


                {/* {this.props.config?.showCart && (
                        <ShoppingCartMenu cart={this.props.cart} colors={this.props.colors} config={this.props.config} width={this.props.width} language={this.props.language} functionsHandler={this.props.functionsHandler} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} />
                    )} */}


                {/* <NotificationsMenu language={this.props.language} width={this.props.width} colors={this.props.colors} />
                    {this.props.types == 'booking' && (
                        <SettingBooking language={this.props.language} width={this.props.width} colors={this.props.colors} />
                    )}
                    {(this.props.config?.showSettings == 'collectionBase' || this.props.config?.showSettings == true) && (
                        <SettingsMenu width={this.props.width} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                    )} */}



                {this.props.config?.topHeaderComponent && (
                    <div className=' flexc' style={{ justifyContent: conditionalWidth(this.props.width, { xs: 'flex-end', sm: 'start' }) }}>
                        {this.props.config?.topHeaderComponent()}
                    </div>
                )}
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderInformation);